import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { policyGroups } from "../config/policyLinks";
import siteConfig from "../config/siteConfig";
import PageMeta from "./PageMeta";
import "../css/policy.scss";

const PolicyCenter = () => (
  <main className="policy-page policy-center">
    <PageMeta
      title="Policy center"
      description={`Policies for shopping with ${siteConfig.brandName}.`}
    />
    <section className="policy-hero">
      <div className="container policy-hero__inner">
        <p className="eyebrow">Customer care</p>
        <h1>Policy center</h1>
        <p>
          Clear information about shopping, payments, privacy, food safety and
          your use of the {siteConfig.brandName} website.
        </p>
        <p className="policy-updated">Last updated {siteConfig.policyEffectiveDate}</p>
      </div>
    </section>
    <div className="container policy-center__content">
      {policyGroups.map((group) => (
        <section key={group.title}>
          <p className="eyebrow">{group.title}</p>
          <div className="policy-card-grid">
            {group.links.map((policy) => (
              <Link className="policy-card" to={policy.to} key={policy.to}>
                <h2>{policy.label}</h2>
                <p>{policy.description}</p>
                <span>Read policy <FiArrowRight aria-hidden="true" /></span>
              </Link>
            ))}
          </div>
        </section>
      ))}
      <div className="policy-contact-note">
        <div>
          <p className="eyebrow">Still have a question?</p>
          <h2>We are here to help.</h2>
        </div>
        <a className="button button--dark" href={`mailto:${siteConfig.contact.email}`}>
          {siteConfig.contact.email}
        </a>
      </div>
    </div>
  </main>
);

export default PolicyCenter;

